import { TranslateFn } from '@blocs.i18n';
import Yup from 'src/utils/yup';

export interface LoginFormValues {
  email: string;
  password: string;
}

export const loginMapper = (values: LoginFormValues): { variables: LoginFormValues } => ({
  variables: {
    email: values.email,
    password: values.password,
  },
});

export const loginInitialValues: LoginFormValues = {
  email: '',
  password: '',
};

export const loginValidation = (t: TranslateFn): Yup.ObjectSchema => {
  return Yup.object().shape({
    email: Yup.string().required(t('common:validation.required')),
    password: Yup.string().required(t('common:validation.required')),
  });
};
